import React from 'react'
import * as Styled from '../components/Tooltip/styled'
import { SEARCH_BOTTOM, SEARCH_RESULT } from './searchSources'

export const sourceSearchTooltip = {
  book: {
    [SEARCH_BOTTOM]: 'What is an ISBN?',
    [SEARCH_RESULT]: 'ISBN',
    tooltipBody: (
      <Styled.TooltipBody>
        An ISBN or International Standard Book Number is a 13 digit number that identifies
        published books.
        <br />
        <br />
        Ex: 978-3-16-148410-0
      </Styled.TooltipBody>
    ),
  },
  journal: {
    [SEARCH_BOTTOM]: 'What is a DOI?',
    [SEARCH_RESULT]: 'DOI',
    tooltipBody: (
      <>
        A DOI, or Digital Object Identifier, is a string of numbers, letters and symbols
        used to identify an article.
        <br />
        <br />
        <Styled.TooltipBody>
          You can find most DOI on the first page, or in the header or footer.
          <br />
          Example: 10.123/456
        </Styled.TooltipBody>
      </>
    ),
  },
}

export const noSearchResultMessage = {
  book: { title: 'Hmm we didn’t find anything', body: 'Try searching by title or ' },
  journal: { title: 'Hmm we didn’t find anything', body: 'Try searching by title or ' },
}
